import React, { useState } from "react";

//import css
import "./Mid-Section-Mobile.scss";

//import components
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";
import Modal from "./TenantModal.jsx";
import SummaryCard from "./SummaryCard.jsx";

//import icons
import { IoIosAdd } from "react-icons/io";
import { CgArrowsExchange } from "react-icons/cg";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { IoPersonAddOutline } from "react-icons/io5";
import TenantsList from "./TenantsList.jsx";
import TenantModificationModal from "./TenantModal.jsx";

const MidSectionTenants = () => {
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState("");
  const [tenantData, setTenantData] = useState({});

  const handleShowModal = (actionType) => {
    setAction(actionType);
    setShowModal(true);
  };

  return (
    <div className="caretaker-tenants-mobile">
      <div className="title-date-and-property">
        <div className="title">Select</div>
        <div className="date-and-property">
          <MonthYearPicker />
          <div className="apartment">
            <select
              id="apartment-select"
              name="apartment"
              className="apartment-dropdown"
            >
              <option value="apartment1">Apartment 1</option>
              <option value="apartment2">Apartment 2</option>
              <option value="apartment3">Apartment 3</option>
            </select>
          </div>
        </div>
      </div>
      <div className="summery-card-container">
        <SummaryCard />
      </div>
      <div className="options-conatiner">
        <div className="title">Actions</div>
        <div className="options">
          <div
            className="individual-option"
            onClick={() => handleShowModal("create new tenant")}
          >
            <div className="icon-circle">
              <IoPersonAddOutline fontSize={20} />
            </div>
            <div className="card-title">Add</div>
          </div>
          <div
            className="individual-option"
            onClick={() => handleShowModal("delete tenant")}
          >
            <div className="icon-circle">
              <IoPersonRemoveOutline />
            </div>
            <div className="card-title">Remove</div>
          </div>
          <div
            className="individual-option"
            onClick={() => handleShowModal("move tenant")}
          >
            <div className="icon-circle">
              <CgArrowsExchange fontSize={20} />
            </div>
            <div className="card-title">Re-locate</div>
          </div>
        </div>
      </div>
      <div className="tenants-list-container">
        <div className="title">Tenant List</div>
        <TenantsList
          handleShowModal={handleShowModal}
          setTenantData={setTenantData}
        />
      </div>
      {showModal && (
        <TenantModificationModal
          setShowPay={setShowModal}
          fieldToShow={action}
          tenantData={tenantData}
          setTenantData={setTenantData}
        />
      )}
    </div>
  );
};

export default MidSectionTenants;
